<div class="sp-row__align">
  <mat-icon
    class="sp-color__accent sp-margin__right sp-icon__min-width"
    *ngIf="order?.origin == in_store_origin">
    storefront
  </mat-icon>
  <mat-icon
    class="sp-color__accent sp-margin__right sp-icon__min-width"
    *ngIf="order?.origin == web_origin && order?.channel == on_session_channel">
    public
  </mat-icon>
  <mat-icon
    class="sp-color__accent sp-margin__right sp-icon__min-width"
    *ngIf="order?.origin == web_origin && order?.channel == off_session_channel">
    link
  </mat-icon>
  <span class="sp-margin__quarter-left sp-text__ellipsized">
    {{ getOriginLabel(order?.origin, order?.channel) || '-' | translate }}
  </span>
</div>
